module.exports = __webpack_public_path__ + "media/images/course/certificado___-b61573ab9813c7b9c0fb3f17a93b1223.png";